<template>
  <div class="birthday-2019-inform-me">
    <div class="auth"
         v-if="render.hasWechatAuth"
    >1、获取微信授权成功</div>
    <div class="qr-code"
         v-if="qrCode"
    >
      <img :src="qrCode.src"
           :alt="qrCode.alt"
      >
    </div>
  </div>
</template>

<script>
  import { getWeChatUserInfo } from '@/services/app';
  import { getInformMeDetail, submitInformMe } from '@/services/birthday';
  import { locationHref } from '@/utils';

  export default {
    name: 'Birthday2019InformMe',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    data() {
      return {
        qrCode: null,
        render: {
          pageTitle: '订阅开售提醒',
          hasWechatAuth: true,
        },
      };
    },
    methods: {
      async getWeChatUserInfo() {
        const data = await getWeChatUserInfo(this.$route.fullPath);
        locationHref(data);
      },
      submitInformMe() {
        setTimeout(async () => {
          const data = await submitInformMe('birthday2019');
          this.qrCode = data.qrCode;
        }, 1000);
      },
      async getInformMeDetail() {
        const data = await getInformMeDetail('birthday2019');
        if (!data.render.hasWechatAuth) {
          this.getWeChatUserInfo();
          return;
        }
        this.render = data.render;
        this.submitInformMe();
      },
    },
    created() {
      this.getInformMeDetail();
    },
  };
</script>

<style scoped>

</style>
